var projectTimeline = {
	"Project timeline": "Chronologie du projet",
	"None planned": "Aucune planification",
	"1-3 months": "1 à 3 mois",
	"4-6 months": "4 à 6 mois",
	"7-12 months": "7 à 12 mois",
	"More than 1 year": "Plus d'un an"
};

export { projectTimeline as default };
